import axios, { Axios } from "axios";
import { json } from "react-router-dom";
import axiosInstance from "src/hooks/axios-interceptor";


//ASSET

export const getPowerData = (body) => {
  return axiosInstance
    .post(`/getPowerData`, body)
    .then((response) => {
     
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};




//private methods

const catchAxiosError = (error) => {
  if (!error.response) {
    // network error
    return json(
      {},
      {
        status: 404,
      }
    );
  } else {
    const code = error.response.status;
    const message = error.message;
    return { errors:[message]}
  }
};
